import React from 'react';
import classes from './style.module.css'
import { Button } from 'react-bootstrap';
import { export_table_to_csv } from '../../util/export/csv-exporter'
import { MODE_HOT_JOCKEY, MODE_MATCHES, HOME, AWAY } from "../../constants/Constants"

const ExportData = props => {

    const exportButtonClickedHandler = () => {
        let filename = props.selectionDate
        let tab = props.currentTab
        filename = filename + "_" + tab.id + "_" + ".csv"
        const html = document.querySelector("#" + tab.id);
        export_table_to_csv(html, filename, props.selectionDate)
    }

return (
    <div className={classes.ExportData}>
        <Button size="sm" variant="dark" onClick={exportButtonClickedHandler}>{props.label}</Button>
    </div>
);
}

export default ExportData;